// The label column also contains the activity icon, so character count must
// leave room for that icon and the gap. The prior threshold let 26-character
// names such as "Active Recovery & Mobility" clip before the marquee started.
export const MATRIX_MARQUEE_THRESHOLD = 18;

export const shouldMarqueeActivityName = (name) => String(name || '').trim().length > MATRIX_MARQUEE_THRESHOLD;

// Activity-list labels share horizontal space with status, macros, and timers.
// Measure the rendered text rather than guessing from character count.
export const isActivityNameOverflow = ({ contentWidth, availableWidth }) => (
  Number.isFinite(contentWidth) && Number.isFinite(availableWidth)
  && contentWidth > availableWidth + 1
);
// Backwards-compatible name for the Dojo matrix consumer.
export const shouldMarqueeMatrixActivityName = shouldMarqueeActivityName;

export default shouldMarqueeMatrixActivityName;
